export class TimeScheduleDay {
    timeSchedulerDayId: number;
    timeScheduleId: number;
    orderNum: number;
    dayType: number;
    workHoursQuantity: number;
}